module.exports = __webpack_public_path__ + "static/media/COMP.d81dcfcc.svg";